import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {PaymentOption} from '../../../../../../domain/models/LineItems/PaymentConfig.model';
import {MembershipModel} from '../../../../../../domain/models/LineItems/Membership.model';
import {SPECS} from '../../../../../../domain/specs';

export const PaymentTypeLabel = ({lineItem}: {lineItem: LineItemModel}) => {
  const {paymentConfig, pricing} = lineItem;
  const {t} = useTranslation();
  const {experiments} = useExperiments();
  const ecomPlanAndBookInPurchaseFlow = experiments.enabled(SPECS.ecomPlanAndBookInPurchaseFlow);

  const getMembershipLabel = (membership: MembershipModel) =>
    t('cart.membershipPayment.lineItem', {
      membership: membership.name,
      unit: membership.redemptionUnit,
      count: membership.redemptionCost,
    });

  const getLabel = () => {
    switch (lineItem.paymentConfig.paymentOption) {
      case PaymentOption.DEPOSIT_ONLINE:
        return paymentConfig.depositAmount.convertedAmount > 0
          ? t('cart.myCartPaymentMethod.deposit.lineItem', {
              price: paymentConfig.depositAmount.formattedConvertedAmount,
            })
          : '';
      case PaymentOption.MEMBERSHIP:
      case PaymentOption.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER:
        return ecomPlanAndBookInPurchaseFlow && paymentConfig.membership?.name
          ? getMembershipLabel(paymentConfig.membership)
          : t('checkout.myCartPaymentMethod.payWithPlan.lineItem');
      case PaymentOption.MEMBERSHIP_OFFLINE:
        return t('cart.myCartPaymentMethod.offlinePlan.lineItemWithoutId');
      case PaymentOption.FULL_PAYMENT_OFFLINE:
        return pricing.unitPrice.convertedAmount > 0 && t('cart.myCartPaymentMethod.offlinePayment.lineItem');
      /* istanbul ignore next */
      default:
        return '';
    }
  };

  return (
    <div>
      <span data-hook={CartItemDataHook.PaymentTypeLabel} className={s.paymentLabel}>
        {getLabel()}
      </span>
    </div>
  );
};
